module.exports = __webpack_public_path__ + "static/media/ZIP.8f46c889.svg";